import React from "react";

const handleAutodeposit = (props) => {
  const options = [
    {
      text: 'What is Interac e-Transfer Autodeposit?',
      handler: props.actionProvider.handleAutodeposit1,
      id: 1,
    },
    {
      text: 'Is Interac e-Transfer Autodeposit secure?',
      handler: props.actionProvider.handleAutodeposit2,
      id: 2
    },
    {
      text: 'How do I register for Interac e-Transfer Autodeposit?',
      handler: props.actionProvider.handleAutodeposit3,
      id: 3
    },
    {
      text: 'I don’t see the ability to register for the Interac e-Transfer Autodeposit feature with my bank.',
      handler: props.actionProvider.handleAutodeposit4,
      id: 4
    },
    {
      text: 'I am not receiving the Interac e-Transfer Autodeposit registration verification email.',
      handler: props.actionProvider.handleAutodeposit5,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container autodeposit-products'>{optionsMarkup}</div>;
};

export default handleAutodeposit;